// 40011   非法请求
// 40012   非法请求
// 40013   车架号无效，请输入17位车架号
// 40014   查询异常，请稍后重试
// 40015   请求已过期  
// 40016   车架号不匹配

export const VIN_ERROR_CODE = {
  ILLEGAL_REQUEST: 40011,
  INVALID_VIN: 40013,
  QUERY_EXCEPTION: 40014,
  EXPIRED_SIGN: 40015,
  VIN_NOT_MATCH: 40016,
}